module.exports = __webpack_public_path__ + "img/7ddeb6a.png";